import React, {Fragment} from "react";
import { styles } from './SidebarBaseMenuIcon';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(styles);

const ButtonDownloadIcon = () => {
    const classes = useStyles();
    return (
        <Fragment>
            <img src={require('../../assets/icons/Download.svg')} alt={'alt'} className={classes.iconXSmallWidth} />
        </Fragment>
    )
}

export default ButtonDownloadIcon;
